module.exports = __webpack_public_path__ + "img/partner4.09bdfe48.jpg";